import {customElement, bindable, autoinject} from "aurelia-framework";
import {bindingMode as BindingMode} from "aurelia-binding";
import {IFormSchemaCollectionController, FormSchemaCollectionController} from "../../../services/formSchema/form-schema-collection-controller";
import {AureliaHelperService} from "../../../services/aurelia-helper-service";
import "./form-schema-panel.css";

@autoinject
@customElement('form-schema-panel')
export class FormSchemaPanel {

    @bindable({ defaultBindingMode: BindingMode.oneWay, defaultValue: false }) collapsible: boolean;
    @bindable({ defaultBindingMode: BindingMode.oneWay, defaultValue: false }) title: string;

    @bindable({ defaultBindingMode: BindingMode.oneWay })
    controller: IFormSchemaCollectionController<any>;

    constructor(
          private aureliaHelperService: AureliaHelperService
    ) {
    }

    showing: boolean = true;

    toggleShowing() {
        if (this.collapsible) {
            this.showing = !this.showing;
        }
    }
    headerDiv: Element;

    bind() {
        if (this.collapsible) {
            // easiest way to assign href value to a div (doesn't work when bound in the html)
            $(this.headerDiv).attr({ href: '#' + this.controller.formSchema.name });
            $(this.headerDiv).css({ cursor: 'pointer' });
        }
    }
}